<template>
    <div class="mx-auto text-center lg:max-w-3xl justify-center py-5">
        <div class="h-auto mx-2 py-2 bg-white md:border md:border-black" v-show="singleCoupon || multiCoupon">
            <p v-if="singleCoupon" v-html="$t(getSingleGiftCopy(singleCoupon), {couponCode: singleCoupon.code, discount: couponDiscount(singleCoupon), remainingBoxes, boxLabel})"></p>
            <p v-if="multiCoupon" v-html="$t('CHOOSE_YOUR_GIFT_MULTI_COUPON', {couponCode: multiCoupon.code, discount: couponDiscount(multiCoupon), minBoxes: multiCoupon.minimumWeeks})"></p>
        </div>
        <div class="flex flex-wrap flex-row-reverse justify-center">
            <div class="flex w-full max-w-xs md:max-w-sm p-2">
                <div class="sm:px-2 py-8 bg-white md:border md:border-black">
                    <img src="@/assets/images/pages/account/gifting/cartoon-multiple-box.png"
                         alt="Regular delivery"
                         class="w-32 mx-auto">
                    <h3>{{ $t('CHOOSE_YOUR_GIFT_DELIVERY_FOR', {price: pricePerSubscriptionDelivery}) }}</h3>
                    <p v-text="$t('CHOOSE_YOUR_GIFT_SEND_A_SET')"/>

                    <button
                        class="btn btn--primary mt-2 text-xs"
                        @click="$emit('select-subscription')"
                        v-text="$t('CHOOSE_YOUR_GIFT_SEND_THEM')"/>

                    <ul class="list-disc font-light text-left text-sm pl-10 pr-5 md:px-10 pt-5">
                        <li v-text="$t('CHOOSE_YOUR_GIFT_CHOOSE_HOW')"/>
                        <li v-text="$t('CHOOSE_YOUR_GIFT_FREE_CARD')"/>
                        <li v-text="$t('CHOOSE_YOUR_GIFT_SET_THEM_UP')"/>
                        <li v-if="isVaseEnabled" v-text="$t('CHOOSE_YOUR_GIFT_USP_VASE', {price: paidVasePrice})"/>
                    </ul>
                </div>
            </div>

            <div class="w-full h-5 background--paper divider--container md:hidden">
                <div class="divider-white--top"></div>

                <div class="divider-white--bottom"></div>
            </div>

            <div class="flex w-full h-auto max-w-xs md:max-w-sm p-2">
                <div class="sm:px-2 py-8 bg-white md:border md:border-black">
                    <img src="@/assets/images/pages/account/gifting/cartoon-one-box.png"
                         alt="One-off box"
                         class="w-32 mx-auto">
                    <h3>{{ $t('CHOOSE_YOUR_GIFT_ONE_OFF', {price: pricePerOneOffDelivery}) }}</h3>
                    <p v-text="$t('CHOOSE_YOUR_GIFT_SEND_ONE')"/>
                    <button class="btn btn--primary mt-2 p-2 text-xs"
                            @click="$emit('select-one-box')"
                            v-text="$t('CHOOSE_YOUR_GIFT_PERFECT')"/>

                    <ul class="list-disc font-light text-left text-sm pl-10 pr-5 nd:px-10 pt-5">
                        <li v-text="$t('CHOOSE_YOUR_GIFT_CHOOSE_DAY')"></li>
                        <li v-text="$t('CHOOSE_YOUR_GIFT_WE_INCLUDE')"></li>
                        <li v-text="$t('CHOOSE_YOUR_GIFT_YOUR_DELIVERY')"></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'GiftTypeBoxes',
    mounted() {
        this.$store.dispatch('gifting/fetchGiftingCoupons');
    },
    computed: {
        ...mapGetters({
            multiCoupon: 'gifting/getMultiGiftCoupon',
            singleCoupon: 'gifting/getSingleGiftCoupon',
            subscription: 'subscription/getActiveSubscription',
        }),
        pricePerSubscriptionDelivery() {
            let price = this.$store.getters['gifting/getPricePerSubscriptionDelivery'];

            return parseInt(price || 0);
        },
        pricePerOneOffDelivery() {
            let price = this.$store.getters['gifting/getPricePerOneOffDelivery'];

            return parseInt(price || 0);
        },
        paidVasePrice() {
            let price = this.$store.getters['gifting/getPaidVasePrice'];

            return parseInt(price || 0);
        },
        isVaseEnabled() {
            return this.$store.getters['account/getGiftingVaseEnabled'];
        },
        remainingBoxes() {
            return this.subscription.single_gift_coupon_remaining_deliveries;
        },
        boxLabel() {
            return (this.remainingBoxes === 1) ? 'box' : 'boxes';
        },
    },
    methods: {
        couponDiscount(coupon) {
            if (coupon.discountType === 'percentage') {
                return `${coupon.discount}%`;
            }
            return `£${coupon.discount * 0.01}`;
        },
        getSingleGiftCopy(coupon) {
            const discount = coupon.discount;
            const remainingBoxes = this.remainingBoxes;
            if (discount === 100) {
                return remainingBoxes > 1 ? 'CHOOSE_YOUR_GIFT_ONE_OFF_MULTI_DELIVERIES_COUPON_FREE' : 'CHOOSE_YOUR_GIFT_ONE_OFF_COUPON_FREE';
            }
            return remainingBoxes > 1 ? 'CHOOSE_YOUR_GIFT_ONE_OFF_MULTI_DELIVERIES_COUPON' : 'CHOOSE_YOUR_GIFT_ONE_OFF_COUPON';
        },
    },
};
</script>
